//import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'Pricelist',
		endpoint: '/pricelist',
		icon: 'mdi-script-text',
		/* item: {
			datereg: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			datebegin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			dateend: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			
			seller: null,
			currency: null,
			type: null,
			category: null,
			direction: null,
			source: null,
			products: [],
		}, */
        items: [],
    },
    actions: {
		/* load (context) {
			return axios.get(context.getters.endpoint).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		}, */
    }
}